import React from "react";
import "./ProductCard.css";
import { responsiveProps } from "../../utils/imageSrc";

/* How wide this image ACTUALLY renders, read off NewProducts.css, which owns
   .product-grid — the only grid that renders this card. Every track is
   `auto-fill`, so the column count is derivable rather than guessed:

     <=480px   1 column, 20px page padding   -> 100vw - 40px
     <=669px   minmax(200px, 1fr), gap 15, padding 20 -> 2 columns (a 3rd
               needs 670px) -> (100vw - 40 - 15) / 2 = 50vw - 27px
     <=768px   same track, now 3 columns     -> (100vw - 40 - 30) / 3
                                              = 33.33vw - 23px
     <=1023px  minmax(200px, 280px), gap 15  -> 3-4 columns, each 233-235px
               right across the range; 240px covers it
     larger    minmax(250px, 320px), gap 20  -> the 320px track cap is the
               widest this card can ever be

   Rounded up, never down: an undersized `sizes` picks too small a candidate
   and the garment looks soft, which is worse than the bytes it saves. */
const CARD_SIZES =
  "(max-width: 480px) calc(100vw - 40px), " +
  "(max-width: 669px) calc(50vw - 27px), " +
  "(max-width: 768px) calc(33.33vw - 23px), " +
  "(max-width: 1023px) 240px, " +
  "320px";

const ProductCard = ({ product }) => {
  const { stock } = product;

  const totalStock = stock.reduce(
    (acc, item) => acc + parseInt(item.quantity, 10),
    0
  );

  // A second photograph, when the product has one, is what makes the hover
  // worth having: the garment itself changes under the cursor. It is layered
  // OVER the primary image and starts at opacity 0, so if it never loads the
  // card is exactly what it was before.
  const images = Array.isArray(product.images) ? product.images : [];
  const secondImage = images[1];

  return (
    <div className="product-card">
      <div className="product-image-wrapper">
        {totalStock <= 0 && <div className="sold-out-badge">Sold Out</div>}
        <img
          className="product-img"
          src={`https://riymay.com/assets/${product.images[0]?.url}`}
          alt={product.images[0]?.altText || product.name}
          loading="lazy"
          {...responsiveProps(images[0], CARD_SIZES)}
        />
        {secondImage?.url && (
          <img
            className="product-img product-img-alt"
            src={`https://riymay.com/assets/${secondImage.url}`}
            alt=""
            aria-hidden="true"
            loading="lazy"
            {...responsiveProps(secondImage, CARD_SIZES)}
          />
        )}
        <div className="product-hover-overlay">
          <button className="quick-shop-btn">Quick Shop</button>
          <div className="sizes-product">
            {product.stock.map((stockItem) => (
              <button
                key={stockItem._id}
                className="size-button-product"
                disabled={stockItem.quantity <= 0}
              >
                {stockItem.size}
              </button>
            ))}
          </div>
        </div>
      </div>

      <div className="product-details">
        <p className="product-card-name">
          {product.name.length > 28
            ? `${product.name.substring(0, 28)}...`
            : product.name}
        </p>
        <p className="product-price">&#8377;{product.price}</p>
      </div>
    </div>
  );
};

export default ProductCard;
